<template>

    <CascoAjanlatBase :titleExtra="titleExtra"  v-if="elozmenyIgazolasVisible()">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatokk">

            <v-layout row wrap>

                <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="elozm_ig_datum" />

                <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="elozm_torl_datum" />

                <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="elozm_bonusz_jogkezd_datum" />

                <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="ajanl_rendszam" />

                <!-- <BnFormField v-if="elozmenyIgazolasVisible()" :attributes="elozoelozorendszam" /> -->

            </v-layout>

        </v-form>

    </CascoAjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';

export default {
    name: 'AjanlatAdatokB4_V0',
    components: { CascoAjanlatBase, BnFormField },
    mixins: [cascoOfferData],
    methods: {
        elozmenyIgazolasVisible() {
            return this.$store.getters.vanCascoBonusz;
        },
    },
    version: 'v0',
    data() {
        return {
            elozm_ig_datum: {
                type: 'date',
                label: 'CASCO előzmény igazolásának dátuma',
                visible: true,
                editable: true,
                mezo: 'elozm_ig_datum',
                path: 'tarifaData.elozm_ig_datum',
                help: true,
            },
            elozm_torl_datum: {
                type: 'date',
                label: 'CASCO előzményszerződés megszűnésének dátuma',
                visible: true,
                editable: true,
                mezo: 'elozm_torl_datum',
                path: 'tarifaData.elozm_torl_datum',
                help: true,
            },
            elozm_bonusz_jogkezd_datum: {
                type: 'date',
                label: 'CASCO előzményszerződés kezdete',
                visible: true,
                editable: true,
                mezo: 'elozm_bonusz_jogkezd_datum',
                path: 'tarifaData.elozm_bonusz_jogkezd_datum',
                help: true,
            },
            ajanl_rendszam: {
                type: 'text',
                label: 'CASCO előzményszerződéshez tartózó gépjármű rendszáma',
                visible: true,
                editable: true,
                mezo: 'ajanl_rendszam',
                path: 'tarifaData.ajanl_rendszam',
                help: true,
            },
            elozoelozorendszam: {
                type: 'text',
                label: 'CASCO előzményszerződés kötvényszáma',
                visible: true,
                editable: true,
                mezo: 'elozoelozorendszam',
                path: 'tarifaData.elozoelozorendszam',
                help: true,
            },
        };
    },
};
</script>
